// image-processing-loader
var previousRequest = require("!!../../../../../node_modules/fox-file-loader/index.js!../../../../../node_modules/file-loader/index.js?name=[path][name].[ext]!./photo-example.jpg");
var dir = previousRequest.replace("photo-example.jpg", "")
module.exports = require("!../../../../../node_modules/fox-image-optimize-plugin/router.js")({
	dir: dir,
	base: "photo-example.jpg",
	name: "photo-example",
	ext: ".jpg",
	query: ""
}, previousRequest);


//////////////////
// WEBPACK FOOTER
// ./images/photo-example.jpg
// module id = 1022
// module chunks = 4